
/**
 * @param {string}currency;
 * @param {string}format;
 * @param {string | ??} price;
 */
export function parsePrice(currency, format, price) {
    let priceConvert;
    if (price) {
        priceConvert = Intl.NumberFormat(format, {
            style: "currency",
            currency: currency,
        }).format(Number(price));
    }
    if (priceConvert) {
        return priceConvert;
    } else {
        return Intl.NumberFormat(format, {
            style: "currency",
            currency: currency,
        }).format(Number(0));
    }
}